import { render, staticRenderFns } from "./Contenedor.vue?vue&type=template&id=504a999d&scoped=true"
import script from "./Contenedor.vue?vue&type=script&lang=js"
export * from "./Contenedor.vue?vue&type=script&lang=js"
import style0 from "./Contenedor.vue?vue&type=style&index=0&id=504a999d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504a999d",
  null
  
)

export default component.exports